export default "__VITE_ASSET__CkkCNy_L__"